export function getYYYYMMDD (v) {
  let date = v || new Date();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  return date.getFullYear() + "-" + month + "-" + strDate;
}

//从一个字符串获取另一个字符串，v字符串的原始值，c要检索出的字符数组类型，按照原始字符串的出现顺序排列 
export function getStrFromStr (v,c) {
  let _v = [];
  for(let i = 0;i<v.length;i++){
    if(c){
      c.map((item)=>{
        if(item == v[i]){
          _v.push(v[i]);
        }
      })
    }
  }
  return _v.join('');
}



// WEBPACK FOOTER //
// ./src/tools.js